module.exports = __webpack_public_path__ + "img/dots.295cb1f8.svg";